"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSubscriptions = exports.EventEmitter = void 0;
var tslib_1 = require("tslib");
var EventEmitter_1 = tslib_1.__importDefault(require("./EventEmitter"));
exports.EventEmitter = EventEmitter_1.default;
var createSubscriptions_1 = tslib_1.__importDefault(require("./createSubscriptions"));
exports.createSubscriptions = createSubscriptions_1.default;
//# sourceMappingURL=index.js.map